// API Endpoints
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    SIGNUP: '/auth/signup',
  },
  FACILITIES: {
    LIST: '/facilities',
    DETAIL: (id: string) => `/facilities/${id}`,
    POPULAR: '/facilities/popular',
  },
  BUILDINGS: {
    LIST: '/buildings',
    DETAIL: (id: string) => `/buildings/${id}`,
  },
  RESERVATIONS: {
    LIST: '/reservations',
    CREATE: '/reservations',
    DETAIL: (id: string) => `/reservations/${id}`,
    CANCEL: (id: string) => `/reservations/${id}/cancel`,
    EXTEND: (id: string) => `/reservations/${id}/extend`,
  },
  REVIEWS: {
    LIST: (facilityId: string) => `/facilities/${facilityId}/reviews`,
    CREATE: '/reviews',
  },
  NOTICES: {
    LIST: '/notices',
    DETAIL: (id: string) => `/notices/${id}`,
  },
  FAQ: {
    LIST: '/faq',
  },
};

// Route Paths
export const ROUTES = {
  HOME: '/home',
  MAIN: '/home',
  LOGIN: '/login',
  FACILITY_DETAIL: '/facility/:id',
  FACILITY_RESERVE: '/facility/:id/reserve1',
  BUILDING_DETAIL: '/building/:id',
  BUILDING_RESERVE: '/building/:id/reserve1',
  RESERVATION: '/reservation',
  MAP: '/map',
  MAP_CATEGORY: '/map/category',
  MYPAGE: '/mypage',
  STATUS: '/status',
  REVIEW: '/review',
  RETURN: '/return',
  EXTENSION: '/extension',
  ALARM: '/Alarm',
  HISTORY: '/history',
  SEARCH: '/search',
  NOTICE: '/notice',
  NOTICE_VIEW: '/noticeView',
  FAQ: '/faq',
  INQUIRY: '/inquiry',
};

// Categories
export const CATEGORIES = [
  { id: 'study', name: '스터디룸', icon: '📚' },
  { id: 'meeting', name: '회의실', icon: '💼' },
  { id: 'equipment', name: '장비대여', icon: '🎥' },
  { id: 'sports', name: '체육시설', icon: '⚽' },
  { id: 'etc', name: '기타', icon: '🏫' },
];

// Time Slots
export const TIME_SLOTS = [
  '09:00', '10:00', '11:00', '12:00',
  '13:00', '14:00', '15:00', '16:00',
  '17:00', '18:00', '19:00', '20:00',
  '21:00', '22:00',
];
